"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lat2y_1 = require("./lat2y");
var lng2x_1 = require("./lng2x");
/**
 * List all tile coordinates that covers the given bounding box and range of z.
 */
function getListOfTilesInBBox(bbox, maxZ, minZ) {
    if (minZ === void 0) { minZ = 0; }
    var result = [];
    for (var z = minZ; z <= maxZ; z += 1) {
        var minX = lng2x_1.lng2x(bbox.minLng, z);
        var maxX = lng2x_1.lng2x(bbox.maxLng, z);
        var maxY = lat2y_1.lat2y(bbox.minLat, z);
        var minY = lat2y_1.lat2y(bbox.maxLat, z);
        for (var x = minX; x <= maxX; x += 1) {
            for (var y = minY; y <= maxY; y += 1) {
                result.push({ z: z, x: x, y: y });
            }
        }
    }
    return result;
}
exports.getListOfTilesInBBox = getListOfTilesInBBox;
//# sourceMappingURL=tiles-of-bbox.js.map